import { privateClient } from '../axios';

export const createAssessment = (data) => privateClient.post('/create/assessmentbundle', data);
